import { Box, Button, Drawer } from "@mui/material";
import React, { ReactNode } from "react";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { ediphiPalette } from "../../styles/colors";

interface DrawerLayoutProps {
  isDrawerOpen: boolean;
  onDrawerClose: () => void;
  drawerTitle: ReactNode;
  children?: ReactNode;
}

// const TRANSITION_DURATION = { enter: 400, exit: 320 };

const FullScreenDrawerLayout = ({ isDrawerOpen, onDrawerClose, drawerTitle, children }: DrawerLayoutProps) => {
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={onDrawerClose}
      // transitionDuration={TRANSITION_DURATION}
      slotProps={{
        paper: { sx: { width: "100%" } },
      }}
      hideBackdrop
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            display: "flex",
            height: "48px",
            flexShrink: 0,
            justifyContent: "center",
            borderBottom: `1px solid ${ediphiPalette.borderDivider}`,
          }}
        >
          <Button
            onClick={onDrawerClose}
            sx={{ position: "absolute", top: 0, left: 0, minWidth: "48px", minHeight: "48px" }}
          >
            <KeyboardDoubleArrowRightIcon
              sx={{ color: ediphiPalette.textBlack, "&:hover": { color: ediphiPalette.brand800 } }}
            />
          </Button>
          {drawerTitle}
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>{children}</Box>
      </Box>
    </Drawer>
  );
};

export default FullScreenDrawerLayout;
